/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_SquadsInputs */

const en_tut_sc_squads = /** @type {(inputs: Tut_Sc_SquadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Squads`)
};

const id_tut_sc_squads = /** @type {(inputs: Tut_Sc_SquadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Squad`)
};

/**
* | output |
* | --- |
* | "Jump to Squads" |
*
* @param {Tut_Sc_SquadsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_squads = /** @type {((inputs?: Tut_Sc_SquadsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_SquadsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_squads(inputs)
	return en_tut_sc_squads(inputs)
});